// extracted by mini-css-extract-plugin
module.exports = {"main":"app_main__1-szo","bodytop":"app_bodytop__sTsU7","body":"app_body__1Zc0q"};